import styled from 'styled-components';
import { COLORS } from '../../styles/variables';

export const DotsContainer = styled.div`
  display: flex;
  width: fit-content;
`;

export const Dot = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 4px;
  border: none;
  background-color: transparent;
  height: 40px;
  cursor: pointer;
`;

export const Bar = styled.div<{ isActive: boolean }>`
  width: 32px;
  height: ${(props) => (props.isActive ? '4px' : '2px')};
  background-color: ${(props) => (props.isActive ? COLORS.black : COLORS.grey60)};
  transition: all 0.5s;
`;
